<ng-template #content let-c="close" let-d="dismiss">
  <div class="lna-modal-header">
    <h4 class="modal-title" id="modal-basic-title">
      {{ 'components.approveSubmission.title' | translate }}
      @if (shouldRenderTooltip) {
        <app-tooltip [text]="'approveSubmissionTimeTitleBackoffice'"/>
      }
    </h4>
    <button class="btn-close" (click)="hide()" type="button" aria-label="Close"></button>
  </div>
  <div class="lna-modal-body">
    <h4 class="modal-question" id="modal-basic-question">
      @if (application?.visitTimeTo) {
        {{
          'components.approveSubmission.approveSubmissionQuestionWithTo'
            | translate
              : {
                  date: formatDate(application?.visitDate!),
                  timeFrom: formatTime(application?.visitTimeFrom),
                  timeTo: formatTime(application?.visitTimeTo)
                }
        }}
      } @else {
        {{
          'components.approveSubmission.approveSubmissionQuestionWithoutTo'
            | translate: { date: formatDate(application?.visitDate!), timeFrom: formatTime(application?.visitTimeFrom) }
        }}
      }
    </h4>
    <form [formGroup]="form">
      <div class="lna-row-32 full-width">
        <div class="label-wrapper">
          <label class="form-label lna" for="text">
            {{ 'components.approveSubmission.informationForClient' | translate }}
          </label>
        </div>
        <div class="textarea-wrapper">
          <textarea
            class="form-control lna m-0"
            id="text"
            [ngClass]="{ invalid: shouldRenderError('informationForClient') }"
            type="text"
            formControlName="informationForClient"
            name="informationForClient"
            maxlength="{{ maxDescriptionLength }}"></textarea>
          <p
            class="length"
            [ngClass]="{
              invalid: informationForClient?.value?.length > maxDescriptionLength
            }">
            {{ informationForClient?.value?.length }}/{{ maxDescriptionLength }}
          </p>
        </div>
        @if (getErrorMessage('informationForClient'); as errorMessage) {
          <div class="error-wrapper">
            <small class="error-message">
              {{ errorMessage | translate }}
            </small>
          </div>
        }
      </div>
    </form>
  </div>
  <div class="lna-modal-footer">
    <button class="primary" (click)="onConfirm()" type="button">Apstiprināt</button>
    <button class="secondary" (click)="hide()" type="button">Atcelt</button>
  </div>
</ng-template>
